import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;
const listeners = new Set();

const push = (features) => {
  cache = features;
  listeners.forEach((fn) => fn(features));
};

export const setFeatures = (settings) => push({
  publisherReturns: settings?.publisher_returns_enabled !== false,
});

/** Feature switches an admin controls in Settings. Defaults to on until told otherwise. */
export const useFeatures = () => {
  const [features, setLocal] = useState(cache || { publisherReturns: true });

  useEffect(() => {
    listeners.add(setLocal);
    if (!cache) api.get("/settings").then(({ data }) => setFeatures(data)).catch(() => {});
    return () => { listeners.delete(setLocal); };
  }, []);

  return features;
};
